export const CannedCategory = {
    SEND_MESSAGE: 1,
    INTERNAL_COMMENT: 2,
};
